import React from "react";
import { parseChatMarkdown } from "../../../../utils/parseChatMarkdown";

export interface ChatBotMessageBodyProps {
  text: string;
  whiteLinks?: boolean;
}

export const ChatBotMessageBody: React.FC<ChatBotMessageBodyProps> = ({
  text,
  whiteLinks,
}) => {
  return (
    <div className="font-secondary whitespace-pre-wrap break-words">
      {parseChatMarkdown({ raws: text ?? "", whiteLinks })}
    </div>
  );
};
